import { Link } from 'react-router-dom';
import { LanguageSwitch, useI18n } from './i18n';

export function Logo() {
  return (
    <svg className="brand-logo" viewBox="255 294 745 660" aria-hidden="true">
      <path d="M263 297L626 531L991 297L996 951H878L879 497L848 520L720 600L613 663L375 503L377 951H258Z" fill="#01193e" />
      <path d="M399 818L492 772V951H399Z" fill="#00dbe7" />
      <path d="M521 750L614 705V951H521Z" fill="#00dbe7" />
      <path d="M642 684L737 634V951H642Z" fill="#00dbe7" />
      <path d="M765 606L855 556V951H765Z" fill="#00dbe7" />
    </svg>
  );
}

export function BrandHeader({ children }) {
  const { t } = useI18n();
  return (
    <header className="brand">
      <Link to="/" className="brand-home">
        <Logo />
        <div>
          <div className="brand-name">Market Matrix</div>
          <div className="brand-tag">{t('Trading Journal')}</div>
        </div>
      </Link>
      <div className="brand-actions">
        {children}
        <LanguageSwitch />
      </div>
    </header>
  );
}
